@let questionsOverview = questionsOverview$ | async;

<div class="mm-questions-visualization-insight-data"
     *ngIf="questionsOverview !== undefined && questionsOverview !== null && levels !== undefined">
    <div class="mm-questions-visualization-insight-data-info">
        <div class="mm-questions-visualization-insight-data-info-text">
                <span
                    [innerHTML]="'learningGoal.insightsPopup.questions.numberOfQuestions' | translate: { numberOfQuestion: questionsOverview.numberOfQuestion } "></span>
            <span *ngIf="questionsOverview.neverAnsweredQuestions === 0"
                  [innerHTML]="'learningGoal.insightsPopup.questions.allQuestionsAnswered' | translate"></span>
            <span *ngIf="questionsOverview.neverAnsweredQuestions === questionsOverview.numberOfQuestion"
                  [innerHTML]="'learningGoal.insightsPopup.questions.noAnsweredQuestions' | translate"></span>
            <span
                *ngIf="questionsOverview.neverAnsweredQuestions > 0 && questionsOverview.neverAnsweredQuestions < questionsOverview.numberOfQuestion"
                [innerHTML]="'learningGoal.insightsPopup.questions.notShowedYetQuestions' | translate: { neverAnsweredQuestions: questionsOverview.neverAnsweredQuestions }"></span>
            <span *ngIf="questionsOverview.numberOfInactiveQuestions > 0 && questionsOverview.numberOfQuestion > 0"
                  [innerHTML]="'learningGoal.insightsPopup.questions.inactiveQuestions' | translate: { numberOfInactiveQuestions: questionsOverview.numberOfInactiveQuestions } "></span>
            <span *ngIf="questionsOverview.numberOfInactiveQuestions > 0 && questionsOverview.numberOfQuestion === 0"
                  [innerHTML]="'learningGoal.insightsPopup.questions.allInactiveQuestions' | translate "></span>
        </div>
        <div class="mm-questions-visualization-insight-data-info-text">
            {{ 'learningGoal.insightsPopup.questions.colorExplanation' | translate }}
        </div>
    </div>
    <div class="mm-questions-visualization-insight-data-questions">
        <div class="mm-questions-visualization-insight-documentation-link">
            <mm-help-icon-link [title]="'learningGoal.insightsPopup.questions.helpButtonTitle' | translate"
                               [link]="'https://taskbase.atlassian.net/wiki/spaces/Micromate/pages/1537839241/Die+Fragen+bersicht'"></mm-help-icon-link>
        </div>
        <div class="mm-questions-visualization-insight-data-questions-chart">
            <svg [attr.height]="size" [attr.width]="size"
                 class="mm-questions-visualization-insight-data-questions-chart-svg">
                <rect
                    *ngFor="let item of [].constructor(elementsPerLine*elementsPerLine); let i = index"
                    [attr.height]="squareWidth"
                    [attr.width]="squareWidth"
                    [attr.x]="calculateXPosition(i)"
                    [attr.y]="calculateYPosition(i)"
                    [style.fill]="calculateBackgroundColor(i)"
                    [style.stroke-width]="strokeWidth"
                    [style.stroke]="'white'"
                />
            </svg>
        </div>
        <div class="mm-questions-visualization-insight-legend">
            <div class="mm-questions-visualization-insight-legend-elements">
                <div
                    class="mm-questions-visualization-insight-legend-element mm-questions-visualization-insight-legend-element-not-answered">
                    <div class="mm-questions-visualization-insight-legend-element-color-box"></div>
                    <div class="mm-questions-visualization-insight-legend-element-text">
                        {{ 'learningGoal.insightsPopup.questions.notAnsweredQuestionLegend' | translate }}
                    </div>
                </div>
                <div
                    class="mm-questions-visualization-insight-legend-element mm-questions-visualization-insight-legend-element-deactivated">
                    <div class="mm-questions-visualization-insight-legend-element-color-box"></div>
                    <div class="mm-questions-visualization-insight-legend-element-text">
                        {{ 'learningGoal.insightsPopup.questions.deactivatedQuestionLegend' | translate }}
                    </div>
                </div>
            </div>
            <div class="mm-questions-visualization-insight-legend-bar">
                <div class="mm-questions-visualization-insight-legend-bar-label">
                    {{ 'learningGoal.insightsPopup.learningProgress' | translate }}
                </div>
                <div class="mm-questions-visualization-insight-legend-bar-value">0%</div>
                <div class="mm-questions-visualization-insight-legend-bar-colors">
                    <div *ngFor="let color of colors"
                         [style.background]="color"
                         class="mm-questions-visualization-insight-legend-bar-colors-element"></div>
                </div>
                <div class="mm-questions-visualization-insight-legend-bar-value">100%</div>
            </div>
        </div>
    </div>
</div>
